<div class="login-container">
  <div class="login-content">
    <h1>Welcome to Fitzidx</h1>
    <p class="subtitle">Please sign in to continue</p>
    
    <app-auth></app-auth>
  </div>
</div>
